export default __webpack_public_path__ + "static/media/site.b759c5c0.svg";